export default "__VITE_ASSET__Rt5J4ftT__"